import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

// Snapshot of what the browser will let us do right now.
export function getPushState() {
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const permission = supported ? Notification.permission : "unsupported";
  return { supported, permission, iosNeedsInstall: isIOS() && !isStandalone() && !supported };
}

export const friendlyPushState = (r) => ({
  denied: "Notifications are blocked for this site — allow them in your browser settings",
  "ios-install": "On iPhone, add MFG to your home screen first, then turn on alerts",
  unsupported: "This browser doesn't support push notifications",
  unconfigured: "Push isn't configured on the server yet",
  default: "Permission wasn't granted",
}[r] || "Could not turn on push");

// Registers (or reuses) a push subscription and stores it server-side.
// Must be called from a user gesture when permission is still "default".
export async function subscribePush({ promptIfNeeded = true } = {}) {
  const { supported, permission } = getPushState();
  if (!supported) return isIOS() && !isStandalone() ? "ios-install" : "unsupported";
  if (permission === "denied") return "denied";
  const { data } = await api.get("/push/public-key");
  if (!data?.key) return "unconfigured";
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    if (permission === "default") {
      if (!promptIfNeeded) return "default";
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return perm;
    }
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.key) });
  }
  const raw = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: raw.endpoint, keys: raw.keys });
  return "granted";
}
